// removed by extract-text-webpack-plugin
module.exports = {"video":"app-pages-Employees-FTUEModal-__FTUEModal___Tlj4-","dialog":"app-pages-Employees-FTUEModal-__FTUEModal___2SIdB","new":"app-pages-Employees-FTUEModal-__FTUEModal___137oh","body":"app-pages-Employees-FTUEModal-__FTUEModal___V2e4a","title":"app-pages-Employees-FTUEModal-__FTUEModal___30ko0","description":"app-pages-Employees-FTUEModal-__FTUEModal___32qCB","compat":"app-pages-Employees-FTUEModal-__FTUEModal___3H09i"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Employees/FTUEModal/FTUEModal.css
// module id = 2320
// module chunks = 0